import { render, staticRenderFns } from "./mallGoodsEdit.vue?vue&type=template&id=6d5583e0&"
import script from "./mallGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./mallGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./mallGoodsEdit.vue?vue&type=style&index=0&id=6d5583e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports